import { render } from "./Quote.vue?vue&type=template&id=c7fefa2e&scoped=true"
import script from "./Quote.vue?vue&type=script&lang=js"
export * from "./Quote.vue?vue&type=script&lang=js"

import "./Quote.vue?vue&type=style&index=0&id=c7fefa2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Zayd\\Documents\\Web Development\\Clients Projects\\RHDesigns\\rhdesigns-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7fefa2e"]])

export default __exports__